//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiPencil,
  mdiDelete,
  mdiCalendarToday,
  mdiCalendarWeek,
  mdiCalendarMonth,
  mdiBell,
  mdiQrcodeScan,
} from '@mdi/js'
import ModalQr from '~/components/crud/ModalQr'

export default {
  name: 'CrudTableItem',
  components: { ModalQr },
  props: {
    item: {
      type: Object,
      default: undefined,
    },
    headers: {
      type: Array,
      default: undefined,
    },
    rowId: {
      type: String,
      default: 'ID',
    },
    tableSearch: {
      type: Object,
      default: undefined,
    },
    selectedOnCurrentPage: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    icons: {
      mdiPencil,
      mdiDelete,
      mdiCalendarToday,
      mdiCalendarWeek,
      mdiCalendarMonth,
      mdiBell,
      mdiQrcodeScan,
    },
    organizationModule: localStorage.getItem('organizationModule'),
  }),

  computed: {
    localSelectedOnCurrentPage: {
      get() {
        return this.selectedOnCurrentPage
      },
      set(value) {
        this.$emit('update:selected-on-current-page', value)
      },
    },
  },

  created() {
    this.initTranslations()
    // this.checkDeviceType()
  },

  methods: {
    initTranslations() {
      this.weekdays = {
        0: this.$t('schedule_plan.day0'),
        1: this.$t('schedule_plan.day2'),
        2: this.$t('schedule_plan.day3'),
        3: this.$t('schedule_plan.day4'),
        4: this.$t('schedule_plan.day5'),
        5: this.$t('schedule_plan.day6'),
        6: this.$t('schedule_plan.day7'),
        7: this.$t('schedule_plan.day1'),
      }
    },

    translateReportTime(report) {
      return this.$t(`buttons.${report}`)
    },

    customModalOpen(item) {
      this.$emit('customModalOpen', item)
    },

    promptDeleteItem(item) {
      this.showConfirmModal = true
      this.focusItem = item
    },

    async deleteItem() {
      this.GlobalError = ''

      const index = this.dataItems.indexOf(this.focusItem)
      this.isLoading = true
      /* Make AXIOS DELETE request */
      await this.$axios
        .delete(this.apiUrl + '/' + this.focusItem.ID + '/')
        .then(() => {
          this.dataItems.splice(index, 1)
          this.$dialog.message.success(this.$t('global.message.success'))
        })
        .catch((error) => {
          if (!error.response) {
            return error
          }
          if (error.response.data.GlobalError) {
            this.GlobalError = error.response.data.GlobalError
          }
        })
        .then(() => {
          Object.assign(this.focusItem, {})
          this.isLoading = false
          this.showConfirmModal = false
        })
    },

    initLazyDataTd(field, td, item) {
      if (!item.lazyData) {
        item.lazyData = {}
      }
      if (!item.lazyData[field]) {
        item.lazyData[field] = td[field](td, item)
      }
      return true
    },

    updateBackUrl(item) {
      const dataItem = Object.assign({}, item)
      dataItem.backUrl = this.$route.fullPath

      this.$store.dispatch('routes/updateBackRoutes', dataItem)
    },
  },
}
